import React from 'react';
import { t } from 'i18next';
import CrmEntityTypeTable from './CrmEntityTypeTable';

export default function CrmOrganisationTypes() {
  return (
    <CrmEntityTypeTable
      endpoint="crm/organisation-types"
      title={t('OrganisationType')}
      addLabel={`${t('Create')} ${t('OrganisationType')}`}
    />
  );
}
